<template>
	<div>
		
	<div id="img-upload"> 
              <!-- 遮罩层 --> 
          		<div class="img-container" v-show="panel">
              			<div>
              				<img id="image" :src="url" alt="Picture">
              			</div>
              			<button type="button" id="img-button-cancel" @click="cancel">取消</button>
              			<button type="button" id="img-button-submit" @click="crop">确定</button>
          			</div>
  					 <div class="picture">
              <div class="user-image text-xs-center mb-3">  
                <Upload multiple
                          ref="upload"
                          name="upfile"
                          :max-size="1024"
                          :format="['jpg','jpeg','png']"
                          :action="uploadUrl"
                          :headers="headers"
                          :with-credentials=true
                          :show-upload-list=false
                          :on-success="uploadSuccess"
                          :before-upload="beforeUpload"
                          >
                      <img  alt="" style="cursor: pointer;" :title="$t('userSetting.uploadImgTitle')" :src="url" class="img-responsive rounded-circle">
                  </Upload>
                </div>     
           </div>
			</div> 



	</div>

</template>
<style>

</style>
<script>
	import Cropper from 'cropperjs'
	export default {
        data(){
            return{
            	uploadUrl:'http://118.126.113.35/user/uploadHeadPortrait',
            	headers: {//设置请求头
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
                },
                headerImage:'',  
		      	picValue:'',  
		      	cropper:'',  
		      	croppable:false,  
		      	panel:false,  
		      	url:''  
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted(){
        	this.initCropper();
		},
        watch:{
            
        },        
        methods: {
          initCropper(){
            //初始化这个裁剪框  
          var self = this; 
          var image = document.getElementById('image'); 
          this.cropper = new Cropper(image, { 
            aspectRatio: 1, viewMode: 1, background:false, zoomable:false, 
            ready: function () { 
              self.croppable = true; } 
            }
            ); 
          },
          cancel(){
            this.panel = false;
          },
        getObjectURL (file) { 
	        var url = null ; 
	        if (window.createObjectURL!=undefined) { // basic  
        	url = window.createObjectURL(file) ; } else if (window.URL!=undefined) { // mozilla(firefox)  
        	url = window.URL.createObjectURL(file) ; } else if (window.webkitURL!=undefined) { // webkit or chrome  
        	url = window.webkitURL.createObjectURL(file) ; } return url ; }, 
        // change (e) { 
        // 	let files = e.target.files || e.dataTransfer.files; 
        // 	console.log(files)
        // 	if (!files.length) return; 
        // 	this.panel = true; 
        // 	this.picValue = files[0]; 
        // 	this.url = this.getObjectURL(this.picValue); //每次替换图片要重新得到新的url  
        // 	if(this.cropper){ 
        // 		this.cropper.replace(this.url); 
        // 	} 
        // 	this.panel = true; 
        // }, 
        crop () { 
        	this.panel = false;
        	 var croppedCanvas; 
        	 var roundedCanvas; 
        	 if (!this.croppable) { 
        	 	return; 
        	 } // Crop  
        	croppedCanvas = this.cropper.getCroppedCanvas(); 
        	console.log(this.cropper) // Round  
        	roundedCanvas = this.getRoundedCanvas(croppedCanvas); 
        	this.headerImage = roundedCanvas.toDataURL(); 
        	this.postImg() 
        }, 
        	getRoundedCanvas (sourceCanvas) { 
        		var canvas = document.createElement('canvas'); 
        		var context = canvas.getContext('2d'); 
        		var width = sourceCanvas.width; 
        		var height = sourceCanvas.height; 
        		canvas.width = width; 
        		canvas.height = height; 
        		context.imageSmoothingEnabled = true; 
        		context.drawImage(sourceCanvas, 0, 0, width, height); 
        		context.globalCompositeOperation = 'destination-in'; 
        		context.beginPath(); 
        		context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true); 
        		context.fill(); 
        		return canvas; 
        	}, 
        	postImg () { //这边写图片的上传  
        		this.$http.post("http://127.0.0.1:7979/userDetail/uploadAvatar/" + this.$store.state.user.id, this.headerImage).then(res => {
        			alert(1)
        		},err => {
        			alert("err")
        		})
        	},
        	beforeUpload(files){
        		console.log(files)
	        	this.panel = true; 
	        	this.picValue = files; 
	        	this.url = this.getObjectURL(this.picValue); //每次替换图片要重新得到新的url  
	        	if(this.cropper){ 
	        		this.cropper.replace(this.url); 
	        	} 
	        	return false;
        	},
        	uploadSuccess:function(response, file, fileList){
                this.userDetail.image = response.result;
                this.$store.state.user.image = response.result;
                localStorage.setItem("image", response.result);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ImageUpload.vue?3b5e34da